import styled from "styled-components";
import {BurgerMenuContainerDefaultBox} from "./burger-menu-container.default.box";

export const BurgerMenuContainerCasino777Box = styled(BurgerMenuContainerDefaultBox)`
    color: ${({theme}) => theme.colors.text};
`;
